import { Link } from "react-router-dom";

// Text wordmark for the top navigation — matches the brand system
// (MY**RED**PARK, tagline beneath). The official image logo is used in
// footer/auth/brand moments via Logo.jsx.
export default function NavWordmark() {
  return (
    <Link to="/" data-testid="logo-link" aria-label="MyRedPark home" className="flex flex-col leading-none shrink-0 select-none">
      <span className="font-display font-extrabold tracking-tight text-[1.15rem] text-white">
        MY<span className="text-[#E50914]">RED</span>PARK
      </span>
      <span className="font-mono text-[0.55rem] tracking-[0.3em] text-zinc-500 mt-1">YOUR SPOT. YOUR WAY.</span>
    </Link>
  );
}
